const carouselItems = [
  {
    title: '台北娜娜深度专题',
    subtitle: '从素人到顶流网红的崛起之路',
    desc: '深度解析台北娜娜从默默无闻到全网爆红背后的完整故事线，包含独家采访片段与粉丝群体分析，还原一个真实的台北娜娜。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20editorial%20photography%20with%20soft%20dramatic%20lighting%2C%20elegant%20crimson%20and%20rose%20gold%20color%20palette%2C%20abstract%20composition%20evoking%20mystery%20and%20celebrity%20culture%2C%20luxurious%20fabric%20textures%2C%20modern%20Chinese%20media%20aesthetic%2C%20no%20text%20no%20faces%20no%20people%2C%20cinematic%20atmosphere&width=900&height=600&seq=carousel-01-taipei-nana&orientation=landscape',
    tag: '深度专题',
  },
  {
    title: '莫里秀全事件复盘',
    subtitle: '直播翻车到道歉的72小时',
    desc: '完整梳理莫里秀直播事件从发生、发酵到最终道歉的全过程，包含多方当事人回应与业内人士分析，读懂事件背后的行业生态。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20dark%20composition%20with%20deep%20burgundy%20and%20warm%20amber%20highlights%2C%20editorial%20photography%20style%2C%20mysterious%20atmosphere%20with%20soft%20shadows%2C%20modern%20Chinese%20entertainment%20media%20aesthetic%2C%20rich%20dark%20textures%2C%20no%20text%20no%20faces%20no%20people%2C%20luxurious%20moody%20tone&width=900&height=600&seq=carousel-02-mori-show&orientation=landscape',
    tag: '事件复盘',
  },
  {
    title: '玩偶姐姐身份调查',
    subtitle: '匿名背后的商业帝国',
    desc: '独家揭秘玩偶姐姐幕后运营团队，从账号矩阵到商业变现全链路分析，揭开这位神秘网红的真实运作模式。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20dark%20editorial%20photography%20with%20crimson%20and%20black%20tones%2C%20abstract%20geometric%20shapes%2C%20mysterious%20and%20luxurious%20atmosphere%2C%20modern%20Chinese%20digital%20media%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20rich%20textures%2C%20no%20text%20no%20faces%20no%20people&width=900&height=600&seq=carousel-03-doll-sister&orientation=landscape',
    tag: '独家调查',
  },
  {
    title: '2026网红塌房年鉴',
    subtitle: '今年那些轰然倒下的人设',
    desc: '盘点2026年上半年最具影响力的网红塌房事件，从偷税漏税到人设崩塌，从法律红线到道德底线，一网打尽年度吃瓜大事件。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20editorial%20composition%20with%20deep%20red%20and%20charcoal%20tones%2C%20abstract%20dramatic%20lighting%2C%20mysterious%20cinematic%20atmosphere%2C%20modern%20Chinese%20gossip%20media%20aesthetic%2C%20rich%20dark%20textures%20with%20warm%20accents%2C%20no%20text%20no%20faces%20no%20people&width=900&height=600&seq=carousel-04-scandal-2026&orientation=landscape',
    tag: '年度盘点',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点深扒
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            深度调查与独家专题，为你呈现最全面的吃瓜视角
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 hover:bg-background-100"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}